import { useTheme } from "@emotion/react";
import React from "react";

import { Link } from "@brexhq/next/src/components/shared/Link";
import { Video } from "@brexhq/next/src/components/shared/Video/video";
import { Text } from "@brexhq/shared/components/Typography/Text";

import { LeadFormSteps } from "../../machines/types";
import { FinalStateViewTemplate } from "../PageTemplates/FinalStateViewTemplate";
import { ButtonWrapper, SuccessContentContainer } from "../Success/Success";

export const ExternalEventSuccess: React.FC = () => {
  const { colors } = useTheme();

  const successGraphic = (
    <Video
      src="https://brand.brex.com/m/2dbccd07ab48f40b/2C323D44-congratsmotion-whitebg.mp4"
      autoPlay
      loop
      muted
    />
  );

  const successTitle = (
    <Text
      as="h2"
      className="_lr-hide dd-privacy-mask"
      color={colors.content.primary}
      margin={{
        LRG: [0, 0, 24, 0],
        MED: [0, 0, 24, 0],
        SML: [0, 0, 24, 0],
      }}
      components={{
        LRG: "Headline3",
        MED: "Headline3",
        SML: "Headline4",
      }}
    >
      {
        "Thank you & enjoy the event. You will receive an email shortly from us with next steps for setting up an account when you're ready."
      }
    </Text>
  );

  const backToHomeButton = (
    <ButtonWrapper>
      <Link
        margin={[0]}
        component="Story"
        modifier="primary"
        to="/"
        label="Back to home"
      />
    </ButtonWrapper>
  );

  return (
    <FinalStateViewTemplate currentLeadFormStep={LeadFormSteps.eventSuccess}>
      <SuccessContentContainer>
        {successGraphic}
        {successTitle}
        {backToHomeButton}
      </SuccessContentContainer>
    </FinalStateViewTemplate>
  );
};
